/* Auto-generated — run: npm run build:broomfield-supplemental */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type BroomfieldSupplementalStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const BROOMFIELD_SUPPLEMENTAL_STAGES: BroomfieldSupplementalStage[] = [
  {
    "date": "June 2026",
    "title": "Watertight and Commissioning",
    "items": [
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/000.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 1 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/001.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 2 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/002.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 3 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/003.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 4 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/004.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 5 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/005.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 6 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/006.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 7 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/007.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 8 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/008.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 9 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/009.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 10 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/010.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 11 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/011.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 12 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/012.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 13 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/013.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 14 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/014.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 15 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/015.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 16 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/016.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 17 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/017.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 18 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/018.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 19 of 20"
      },
      {
        "src": "/progress/broomfield/19-watertight-and-commissioning/019.jpg",
        "type": "image",
        "alt": "Watertight and Commissioning, photo 20 of 20"
      }
    ]
  },
  {
    "date": "May 2026",
    "title": "Facade and Internal Fit-Out",
    "items": [
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/000.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 1 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/001.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 2 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/002.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 3 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/003.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 4 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/004.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 5 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/005.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 6 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/006.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 7 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/007.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 8 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/008.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 9 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/009.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 10 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/010.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 11 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/011.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 12 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/012.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 13 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/013.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 14 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/014.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 15 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/015.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 16 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/016.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 17 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/017.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 18 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/018.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 19 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/019.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 20 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/020.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 21 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/021.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 22 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/022.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 23 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/023.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 24 of 25"
      },
      {
        "src": "/progress/broomfield/18-facade-and-internal-fit-out/024.jpg",
        "type": "image",
        "alt": "Facade and Internal Fit-Out, photo 25 of 25"
      }
    ]
  },
  {
    "date": "April 2026",
    "title": "External Masonry and Fit-Out",
    "items": [
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/000.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 1 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/001.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 2 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/002.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 3 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/003.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 4 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/004.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 5 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/005.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 6 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/006.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 7 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/007.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 8 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/008.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 9 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/009.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 10 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/010.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 11 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/011.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 12 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/012.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 13 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/013.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 14 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/014.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 15 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/015.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 16 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/016.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 17 of 18"
      },
      {
        "src": "/progress/broomfield/17-external-masonry-and-fit-out/017.jpg",
        "type": "image",
        "alt": "External Masonry and Fit-Out, photo 18 of 18"
      }
    ]
  }
];
